import { render } from "./InvitationSummary.molecules.vue?vue&type=template&id=ca4e1e86&ts=true"
import script from "./InvitationSummary.molecules.vue?vue&type=script&lang=ts"
export * from "./InvitationSummary.molecules.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__